/**
 * Education systems + grade ladders for the dashboard.
 * MUST stay in sync with the mobile app (`lib/utils/year_groups.dart`) and the
 * backend (`pear-payments-backend/src/ladders.js`).
 */
export type EducationSystem = "CBC" | "CAMBRIDGE" | "AMERICAN";

export const EDUCATION_SYSTEMS: { value: EducationSystem; label: string }[] = [
  { value: "CBC", label: "CBC (Kenya)" },
  { value: "CAMBRIDGE", label: "Cambridge / British" },
  { value: "AMERICAN", label: "American" },
];

export const GRADE_LADDERS: Record<EducationSystem, string[]> = {
  CBC: [
    "PP1", "PP2",
    "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6",
    "Grade 7", "Grade 8", "Grade 9", "Grade 10", "Grade 11", "Grade 12",
  ],
  CAMBRIDGE: [
    "Year 1", "Year 2", "Year 3", "Year 4", "Year 5", "Year 6", "Year 7",
    "Year 8", "Year 9", "Year 10", "Year 11", "Year 12", "Year 13",
  ],
  AMERICAN: [
    "Pre-K", "Kindergarten",
    "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6",
    "Grade 7", "Grade 8", "Grade 9", "Grade 10", "Grade 11", "Grade 12",
  ],
};

/** Ordered grades for a system; falls back to Cambridge when unset. */
export function ladderFor(system?: string | null): string[] {
  const key = (system || "").toUpperCase() as EducationSystem;
  return GRADE_LADDERS[key] ?? GRADE_LADDERS.CAMBRIDGE;
}

export function isValidSystem(system?: string | null): system is EducationSystem {
  return !!system && system.toUpperCase() in GRADE_LADDERS;
}

/** Next grade up; null at the top (graduating) or if the grade isn't on the ladder. */
export function nextGrade(system: string | null | undefined, current: string): string | null {
  const ladder = ladderFor(system);
  const i = ladder.findIndex((g) => g.toLowerCase() === current.trim().toLowerCase());
  if (i < 0 || i >= ladder.length - 1) return null;
  return ladder[i + 1];
}
